import { Button, Modal, Typography } from '@anchor/react-components/dist/lib/components'
import React from 'react'

function PhotoPreviewModal({imageToPreview, previewModal, hanldePreviewModal}) {
  if (!imageToPreview) {
    return null;
  }
  
  return (
    <Modal
        backdropcloseactiondisabled={true}
        width="1200"
        height="600"
        dimension="large"
        //  height="20%"
        // maxHeight="40vh"
        // maxWidth="80vw"
        actions={{
          secondaryAction: (
            <Button
              label="Close"
              onClick={hanldePreviewModal}
              variant="outlined"
            />
          ),
        }}
        heading=<Typography
          variant="h2"
          fontStyle="bold"
          style={{
            fontSize: "16px",
            padding: "10px",
            textAlign: "",
            marginLeft: "20px",
          }}
        >
          {imageToPreview.fileName}
        </Typography>
        onClose={hanldePreviewModal}
        showCloseIcon
        open={previewModal}
      >
        <div className="proxy-renderer">
          <div
            className="imageBackground"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <img
              style={{ maxWidth: "95%", maxHeight: "95%" }}
              src={imageToPreview.preview}
            />
          </div>
        </div>
      </Modal>
  )
}

export default PhotoPreviewModal